import PropTypes from 'prop-types';

import constants from '../constants/common';

const { MENU_ITEMS } = constants;

export const getIndexDropdownMenuItemsConfig = (ott = false) => {
  return {
    authorized: {
      desktop: [
        MENU_ITEMS.profile,
        MENU_ITEMS.virtualcard,
        MENU_ITEMS.achievements,
        // TODO remove comment when needed
        // MENU_ITEMS.travelexpert,
        MENU_ITEMS.exit,
      ],
      mobile: [
        MENU_ITEMS.profile,
        MENU_ITEMS.virtualcard,
        MENU_ITEMS.achievements,
        // TODO remove comment when needed
        // MENU_ITEMS.travelexpert,
        MENU_ITEMS.exit,
      ],
    },
    notAuthorized: {
      desktop: [],
      mobile: ott
        ? [MENU_ITEMS.orderOtt, MENU_ITEMS.supportLink, MENU_ITEMS.mobileLogin]
        : [MENU_ITEMS.order, MENU_ITEMS.mobileLogin],
    },
  };
};

getIndexDropdownMenuItemsConfig.propTypes = {
  ott: PropTypes.bool,
};

export const getIndexMenuItemsConfig = () => {
  return {
    authorized: [MENU_ITEMS.profile],
    notAuthorized: {
      desktop: [MENU_ITEMS.profileLogin],
      mobile: [],
    },
  };
};

export const getProductsDropdownMenuItemsConfig = (ott = false) => {
  return {
    authorized: [
      MENU_ITEMS.profile,
      MENU_ITEMS.virtualcard,
      MENU_ITEMS.achievements,
      // TODO remove comment when needed
      // MENU_ITEMS.travelexpert,
      MENU_ITEMS.exit,
    ],
    notAuthorized: {
      desktop: [],
      mobile: ott
        ? [MENU_ITEMS.orderOtt, MENU_ITEMS.supportLink, MENU_ITEMS.mobileLogin]
        : [MENU_ITEMS.order, MENU_ITEMS.mobileLogin],
    },
  };
};

getProductsDropdownMenuItemsConfig.propTypes = {
  ott: PropTypes.bool,
};

export const getProductsMenuItemsConfig = (ott = false) => {
  return {
    authorized: [MENU_ITEMS.profile],
    notAuthorized: {
      desktop: ott
        ? [MENU_ITEMS.orderOtt, MENU_ITEMS.supportLink, MENU_ITEMS.login]
        : [MENU_ITEMS.order, MENU_ITEMS.login],
      mobile: [],
    },
  };
};

getProductsMenuItemsConfig.propTypes = {
  ott: PropTypes.bool,
};
